// src/contexts/UserProvider.js
import React, { useState, useEffect } from "react";
import UserContext from "./Usercontext";

const UserProvider = ({ children }) => {
  const [userId, setUserId] = useState("");

  useEffect(() => {
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  return (
    <UserContext.Provider value={{ userId }}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
